import { createSelector } from 'reselect';

const selectTenants = (state: any) => state.tenants;


export const selectTenantsCurrentItem = createSelector([selectTenants], (tenants) => tenants.current);

export const selectTenantsListItems = createSelector([selectTenants], (tenants) => tenants.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectTenantsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTenantsQueryItems = createSelector([selectTenants], (tenants) => tenants.query);

export const selectTenantsCreatedItem = createSelector([selectTenants], (tenants) => tenants.create);

export const selectTenantsUpdatedItem = createSelector([selectTenants], (tenants) => tenants.update);

export const selectTenantsReadItem = createSelector([selectTenants], (tenants) => tenants.read);

export const selectTenantsDeletedItem = createSelector([selectTenants], (tenants) => tenants.delete);

export const selectTenantsSearchedItems = createSelector([selectTenants], (tenants) => tenants.search);

export const selectTenantsItemsCount = createSelector([selectTenants], (tenants) => tenants.count);

export const selectTenantsItemsFilter = createSelector([selectTenants], (tenants) => tenants.filter);